import { render, staticRenderFns } from "./StepBasicConfiguration.vue?vue&type=template&id=62a6d8ba"
import script from "./StepBasicConfiguration.vue?vue&type=script&lang=js"
export * from "./StepBasicConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports